import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RestService } from '../../../shared/shared.module';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InstructionsComponent implements OnInit {

  public myTemplate: any = '';
  constructor(private restService: RestService) {
    this.restService.urlGet<string>('/assets/Documents/instructions.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/instructions/instructions.component.ts